import { useMemo, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ComicCard from "@/components/base/ComicCard";
import { Link } from "react-router-dom";
import { comics, genres } from "@/mocks/comics";
import { useSeo } from "@/hooks/useSeo";

const listSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "扑飞漫画网漫画库",
  description: "扑飞漫画网热门漫画列表，涵盖热血冒险、玄幻奇幻、都市生活、悬疑推理、治愈日常、科幻机甲与武侠古风等题材。",
  url: "https://biblioapp.github.io/comics",
};

export default function Comics() {
  useSeo(
    "扑飞漫画网漫画库 - 热门漫画列表与分类",
    "扑飞漫画网漫画库汇集热血冒险、玄幻奇幻、都市生活、悬疑推理、治愈日常、科幻机甲、武侠古风等题材漫画，支持分类筛选与灵活阅读。"
  );

  const [active, setActive] = useState("全部");
  const [keyword, setKeyword] = useState("");

  const filtered = useMemo(() => {
    let list = comics;
    if (active !== "全部") {
      list = list.filter((c) => c.genre === active);
    }
    if (keyword.trim()) {
      const kw = keyword.trim();
      list = list.filter(
        (c) => c.title.includes(kw) || c.author.includes(kw) || c.tags.some((t) => t.includes(kw))
      );
    }
    return list;
  }, [active, keyword]);

  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-[72px]">
        <section className="border-b border-background-200/70 bg-background-100/70">
          <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
            <nav aria-label="面包屑" className="mb-4 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-500">首页</Link>
              <span className="mx-2">/</span>
              <span className="text-foreground-800">漫画库</span>
            </nav>
            <h1 className="text-3xl leading-snug md:text-5xl">漫画库</h1>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              海量人气漫画持续更新，翻页下拉随你切换，按题材筛选，找到最合口味的那一部。
            </p>
          </div>
        </section>

        <script type="application/ld+json">{JSON.stringify(listSchema)}</script>

        <section className="mx-auto w-full max-w-7xl px-4 py-8 md:px-8 md:py-10">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-wrap gap-2">
              {genres.map((g) => (
                <button
                  key={g}
                  type="button"
                  onClick={() => setActive(g)}
                  className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                    active === g
                      ? "bg-primary-500 text-background-50"
                      : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
                  }`}
                >
                  {g}
                </button>
              ))}
            </div>
            <div className="relative w-full sm:w-64">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画或作者"
                aria-label="搜索漫画"
                className="w-full rounded-md border border-background-200 bg-background-50 py-2 pl-9 pr-3 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
              />
            </div>
          </div>

          {filtered.length > 0 ? (
            <div className="mt-8 grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4">
              {filtered.map((c) => (
                <ComicCard key={c.id} comic={c} />
              ))}
            </div>
          ) : (
            <div className="mt-16 flex flex-col items-center text-center">
              <i className="ri-inbox-line text-4xl text-foreground-300" />
              <p className="mt-4 text-sm text-foreground-500">没有找到匹配的漫画，换个关键词或分类试试吧。</p>
            </div>
          )}
        </section>
      </main>
      <Footer />
    </>
  );
}